import { useEffect } from "react";
import { keyPressAction } from "../../Pages/KeyCodeEvents";

export const useEditorKeyboardShortcuts = ({
  bannerId,
  tempSelect,
  updateCompValues,
  setVerticalLineFor,
  compCountRef,
  setCount,
  setShowPaste,
  setVisibility,
  tempLayer,
  setLayerCompData,
  copiedComponentRef,
  refCountZindex,
  refMultiselected,
  setMultiSelectedComps,
  setCopiedComponent,
  componentType,
  imageOnCanvas,
  setSelectedComponent,
  playPauseRef,
  handleDeleteKey,
}) => {
  useEffect(() => {
    const captureKeyCodes = (event) => {
      if (
        tempSelect?.current?.componentStyles?.lockBoolean ||
        tempSelect?.current?.componentStyles?.hideBoolean ||
        !playPauseRef?.current?.animationCompleted
      )
        return;
      keyPressAction(event, tempSelect, updateCompValues, setVerticalLineFor, {
        count: compCountRef.current,
        setCount: setCount,
        setShowPaste: setShowPaste,
        setVisibility: setVisibility,
        layerCompData: [...tempLayer.current],
        setLayerCompData: setLayerCompData,
        copiedComponent: copiedComponentRef.current,
        countZindex: refCountZindex.current,
        multiSelectedComps: [...refMultiselected.current],
        setMultiSelectedComps: setMultiSelectedComps,
        setCopiedComponent: setCopiedComponent,
        componentType: componentType,
        imageOnCanvas: imageOnCanvas,
        setSelectedComponent: setSelectedComponent,
        selectedComponent: tempSelect.current,
      });

      handleDeleteKey(event);
    };

    document.addEventListener("keydown", captureKeyCodes, false);
  }, [bannerId]);
};
